import { Routes, Route, Navigate } from "react-router-dom";
import React from "react";
import PrivateRoute from "../../authentication/helper/PrivateRoute";
import Dashboard from "../../dashboard/Dashboard";
import Analytics from "../../analytics/Analytics";
import ProfileAnalytics from "../../analytics/ProfileAnalytics"
import Performance from "../../performance/Performance"
import Profile from "../../profile/Profile";
import Connections from "../../network/Connections";
import MyConnections from "../../network/MyConnections";
import Contacts from "../../network/Contacts";
import Notifications from "../notifications/Notifications";
import AccountSettings from "./AccountSettings";
import Payment from "../../dashboard/Payment";
import MyProfile from "../../profile/MyProfile";
import MapLoad from "../../network/MapLoad";
import SubscriptionPlan from "./SubscriptionPlan";


// import Contacts from "../network/Contacts";
// import MyConnections from "../network/MyConnections";
// import Notification from "../notifications/Notification";
// import { PaymentCard } from "../Payments/PaymentCard";
// import DashboardPro from "../dashboard/DashboardPro";

const UserRoutes = () => {

    return (
        <Routes>
            <Route element={<PrivateRoute />} >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/dashboardPayment" element={<Payment />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/profile-analytics" element={<ProfileAnalytics />} />
                <Route path="/performance" element={<Performance />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/my-profile" element={<MyProfile />} />
                <Route path="/network" element={<Connections />} />
                <Route path="/my-connections" element={<MyConnections />} />
                <Route path="/contact/:id/" element={<Contacts />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/accountSettings" element={<AccountSettings />} />
                <Route path="/subscriptionPlan" element={<SubscriptionPlan />}/>
                <Route path="/map" element={<MapLoad />} />
                {/* <Route path="/crop" element={<CropperImg />} /> */}
                {/* <Route path='/crop1' element={<ImageCronp />} /> */}
                <Route path="*" element={<Navigate replace to="/dashboard" />} />

                {/* <Route path="/notifications" element={<Notification />} />
                    <Route path="/paymentCard" element={<PaymentCard />} />
                    <Route path="/dashboard" element={<DashboardPro />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/analytics" element={<Analytics />} />
                    <Route path="/network" element={<Network />} />
                    <Route path="/my-connections" element={<MyConnections />} />
                    <Route path="/performance" element={<Performance />} />
                    <Route path="/contact/:id/" element={<Contacts />} /> */}
            </Route>
        </Routes>
    );
};
export default UserRoutes;
